import AidApplicationView from '@/template/views/AidApplicationView.vue';
import BasicInfoView from '@/template/components/aidApplication/BasicInfoView.vue';
import OperationView from '@/template/components/aidApplication/OperationView.vue';
import PartnersView from '@/template/components/aidApplication/PartnersView.vue';
import BudgetaryEstimateView from '@/template/components/aidApplication/BudgetaryEstimateView.vue';
import ContactInfoView from '@/template/components/shared/ContactInfoView.vue';
export var route = {
    path: '/aidApplication/:id',
    component: AidApplicationView,
    children: [
        {
            name: 'aidApplication',
            path: '',
            component: BasicInfoView,
            meta: {
                title: 'AidApplication.Menu.BasicInfo',
                section: 1
            }
        },
        {
            name: 'operation',
            path: 'operation',
            component: OperationView,
            meta: {
                title: 'AidApplication.Menu.Operation',
                section: 2
            }
        },
        {
            name: 'partners',
            path: 'partners',
            component: PartnersView,
            meta: {
                title: 'AidApplication.Menu.Partners',
                section: 3
            }
        },
        {
            name: 'budgetary-estimate',
            path: 'budgetaryEstimate',
            component: BudgetaryEstimateView,
            meta: {
                title: 'AidApplication.Menu.BudgetaryEstimate',
                section: 4,
                procurationRequired: true
            }
        },
        {
            name: 'aid-application-contact-information',
            path: 'aidApplicationContactInformation',
            component: ContactInfoView,
            meta: {
                title: 'AidApplication.Menu.ContactInfo',
                section: 5
            }
        }
    ]
};
